// Fade-up on scroll
(function () {
  if (!window.IntersectionObserver) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  [].slice.call(document.querySelectorAll('.prod-card, .sbox, .fb-cards')).forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    obs.observe(el);
  });
})();

// Cart count + AJAX add-to-cart
(function () {
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var btn = document.getElementById('cartBtn');
        if (btn) {
          var label = (window.HolyShop && window.HolyShop.cartLabel) || 'Panier';
          btn.innerHTML = '🛍️ <span class="cart-text">' + label + '</span> (' + cart.item_count + ')';
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        btn.textContent = '✓ Ajouté !';
        btn.style.background = 'var(--teal)';
        btn.style.color = '#fff';
        refreshCartCount();
      })
      .catch(function () {
        btn.textContent = 'Erreur';
      })
      .then(function () {
        setTimeout(function () {
          btn.textContent = original;
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);
      });
  });

  refreshCartCount();
})();

// Sans Jugement carousel (stack 3D auto-rotate)
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) return;

  [].slice.call(document.querySelectorAll('[data-sj-carousel]')).forEach(function (el) {
    var cards = [].slice.call(el.querySelectorAll('.sj-carousel__card'));
    if (cards.length < 2) return;

    var current = 0;
    var paused = false;

    function next() {
      if (paused) return;
      var leaving = cards[current];
      current = (current + 1) % cards.length;
      var entering = cards[current];

      leaving.classList.remove('sj-carousel__card--active');
      leaving.classList.add('sj-carousel__card--leaving');

      requestAnimationFrame(function () {
        entering.classList.add('sj-carousel__card--active');
      });

      setTimeout(function () {
        leaving.classList.remove('sj-carousel__card--leaving');
      }, 650);
    }

    el.addEventListener('mouseenter', function () { paused = true; });
    el.addEventListener('mouseleave', function () { paused = false; });

    setInterval(next, 3000);
  });
})();
